import { MotionPlugin } from '@vueuse/motion'

export const motion = {
    install: (app) => {
        app.use(MotionPlugin)
    },
};